import { useColorScheme } from 'colorScheme'

/**
 * BuyerFlo lockup — brand mark + "Buyer<accent>Flo</accent>" wordmark.
 *
 * Inlined (rather than an <img>) so the "Buyer" wordmark can follow the active
 * color scheme: dark slate in light mode, white in dark mode. "Flo" and the
 * brand mark stay teal in both. Mirrors mobile's BrandLogo.
 */
export default function BrandLogo({ height = 36 }: { height?: number }) {
    const { resolvedScheme } = useColorScheme()
    const buyerFill = resolvedScheme === 'dark' ? '#FFFFFF' : '#1E293B'

    return (
        <svg
            viewBox="0 0 1100 320"
            xmlns="http://www.w3.org/2000/svg"
            style={{ height, width: 'auto', display: 'block' }}
        >
            <g transform="translate(20, 10)">
                <rect x="0" y="0" width="300" height="300" rx="50" fill="#0F9690" />
                <circle cx="150" cy="120" r="56" fill="#FFFFFF" />
                <rect x="128" y="145" width="44" height="96" rx="7" fill="#FFFFFF" />
                <circle cx="150" cy="120" r="24" fill="#F47068" />
            </g>
            <g transform="translate(370, 160)">
                <text
                    fontFamily="Helvetica, Arial, sans-serif"
                    fontSize="170"
                    fontWeight="300"
                    fill={buyerFill}
                    letterSpacing="2"
                    dominantBaseline="central"
                >
                    <tspan>Buyer</tspan>
                    <tspan fontWeight="700" fill="#0F9690">
                        Flo
                    </tspan>
                </text>
            </g>
        </svg>
    )
}
